import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import Logo from '../icons/Logo';
import LogoMedium from '../icons/LogoMedium';
import EmptyButton from '../buttons/Empty';
import Label from './Label';

import useWindowSize from '../../hooks/useWindowSize';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/header.scss';

const propTypes = {
    color: AppPropTypes.color,
    theme: PropTypes.string,
    donationUrl: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: null,
    theme: 'dark',
    donationUrl: null,
    className: null,
};

const Header = ({ color, theme, donationUrl, className }) => {
    const { width } = useWindowSize();
    const small = width < 1200;
    const mainColor = theme === 'dark' ? '#FFF' : color;

    return (
        <header
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner} style={{ color: mainColor }}>
                <div className={styles.col}>
                    <Link to="/">
                        {small ? (
                            <Logo className={styles.logo} />
                        ) : (
                            <LogoMedium className={styles.logo} />
                        )}
                    </Link>
                </div>
                <div className={styles.col}>
                    <EmptyButton
                        className={styles.support}
                        href={
                            donationUrl ||
                            'https://app.simplyk.io/fr/donation-form/96976ebc-12f4-45dd-905c-065261864afa'
                        }
                        external
                        target="_blank"
                        color={mainColor}
                        theme={theme}
                    >
                        <Label>{{ id: 'content.donation' }}</Label>
                    </EmptyButton>
                </div>
            </div>
        </header>
    );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
